











































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import moment from 'moment';
import * as api from '@/api';
import * as models from '@/api/models';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
import sessionModule, { IUserSession } from '@/store/modules/session';
import classDetail from '@/views/classDetail.vue';
@Component({
  components: { classDetail },
})
export default class ClassList extends Vue {
  @Prop({ default: 0 }) index: number;
  loading: boolean = false;
  finished: boolean = false;
  tabsActive: number = 0;
  listData: any = [];
  currentPage: number = 1;
  totalItemCount: number = 0;
  tabList = [
    {
      index: 0,
      title: '报名中',
    },
    {
      index: 1,
      title: '未开始培训',
    },
    {
      index: 2,
      title: '培训中',
    },
    {
      index: 3,
      title: '已结束',
    },
  ];

  listQuery = {
    state: 0,
    pageIndex: 1,
    pageSize: 5,
  };
  async onLoad(index: number = 0, pageNumber: number = 1) {
    this.getList(index, pageNumber);
  }

  async getList(index: number, pageNumber: number = 1) {
    this.listQuery.state = index;
    this.listQuery.pageIndex = pageNumber;
    this.loading = true;
    try {
      const { data } = await api.ClassSolution.findClassSolutions_GET({
        state: this.listQuery.state,
        pageIndex: this.listQuery.pageIndex,
        pageSize: this.listQuery.pageSize,
      });
      this.listData = data!.items;
      this.totalItemCount = data!.totalItemCount;
      this.currentPage = data!.pageNumber;
      if (this.listData) {
        //办班方案审核状态转成文字
        // for (let item of this.listData) {
        //   switch (item.auditStatus) {
        //     case models.ClassesSolutionAuditStatus.待审核:
        //       this.$set(item, 'auditStatus', '待审核');
        //       break;
        //     case models.ClassesSolutionAuditStatus.已通过:
        //       this.$set(item, 'auditStatus', '已通过');
        //       break;
        //     case models.ClassesSolutionAuditStatus.未通过:
        //       this.$set(item, 'auditStatus', '未通过');
        //       break;
        //     case models.ClassesSolutionAuditStatus.待修改:
        //       this.$set(item, 'auditStatus', '待修改');
        //       break;
        //     case models.ClassesSolutionAuditStatus.未提交:
        //       this.$set(item, 'auditStatus', '未提交');
        //       break;
        //   }
        // }
      }
    } finally {
      this.loading = false;
      this.finished = true;
    }
  }
  tabsChange(index: number, pageNumber: number = 1) {
    this.getList(index, pageNumber);
  }
  pageChange(pageNumber: number) {
    this.getList(this.listQuery.state, pageNumber);
  }
  toClassDetail(classSolution: models.TrainClassDto) {
    this.$router.push({ name: 'classDetail', params: { classSolution: JSON.stringify(classSolution) } });
  }
}
